/* eslint-disable*/
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { fetchAsyncCategory1 } from 'feactures/category/categorySlice';
import {
  Box,
  Container,
  Typography,
  CircularProgress
} from '@material-ui/core'; // eslint-disable-line
import NewButtongroup from 'components/atoms/group/NewButtongroup';
import NewPullDown from 'components/atoms/button/NewPullDown';
import RankingTotal from 'components/organisms/content/category/RankingTotal';
import { categoryRankStatus } from 'feactures/category/categoryRankSlice';
import {
  categorygraphStatus,
  fetchAllCategoryGraphData,
  fetchCategoryBrandGraphData
} from 'feactures/brand/categoryBrandGraphSlice';
import { currentchannel } from 'feactures/channel/channelSlice';
import { userinfo } from 'feactures/user/userSlice';
import {
  currentAcate1,
  currentRcate1,
  currentYcate1
} from 'feactures/category/categoryGraphSlice';
import {
  amazonCategory,
  rakutenCategory,
  yahooCategory
} from 'feactures/category/categorySlice';
import StickyAnnotation from 'components/atoms/annotation/StickyAnnotation';
import NewDialogSelect from 'components/atoms/select/NewDialogSelect';
import FavoriteCategoryPullDown from 'components/atoms/button/FavoriteCategoryPullDown';
import DialogCheckbox from 'components/atoms/select/DialogCheckbox';
import BrandTotal from 'components/organisms/content/brand/BrandTotal';
import BrandItemShare from 'components/organisms/content/brand/BrandItemShare';
import BrandTable from 'components/organisms/content/brand/BrandTable';
import BrandItemTable from 'components/organisms/content/brand/BrandItemTable';
import BrandItemShareTable from 'components/organisms/content/brand/BrandItemShareTable';
import MarketLabel from 'components/molecules/dashboard/MarketLabel';
import BrandLabel from 'components/molecules/dashboard/BrandLabel';
import {
  categoryOtherBrandShareStatus,
  fetchCategoryBrandShareGraphData
} from 'feactures/brand/categoryBrandShareSlice';
import { fetchBrandRankData } from 'feactures/brand/brandRankSlice';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { changePage } from 'feactures/date/dateSlice';
import FreePlanRegisterModal from 'components/atoms/modal/FreePlanRegisterModal';

const BrandAnalysis = ({
  freePlanRegisterModalOpen,
  updateFreePlanRegisterInfosSuccessFlag
}) => {
  const channel = useSelector(currentchannel);
  const userInfo = useSelector(userinfo);
  const top100loading = useSelector(categoryRankStatus);
  const graphloading = useSelector(categorygraphStatus); //こっちの方がloading時間が長いので一旦こっち
  // const brandloading = useSelector(brandLoading);
  const categoryShareLoading = useSelector(categoryOtherBrandShareStatus);
  const currentSelectAmazonCategory1 = useSelector(currentAcate1);
  const currentSelectRakutenCategory1 = useSelector(currentRcate1);
  const currentSelectYahooCategory1 = useSelector(currentYcate1);
  const amazonCategories = useSelector(amazonCategory);
  const rakutenCategories = useSelector(rakutenCategory);
  const yahooCategories = useSelector(yahooCategory);
  // const getBrandList = useSelector(brandList);
  const [yokoziku, setYokoziku] = useState([]);
  const dispatch = useDispatch();

  // 戻るボタン押されたとき用
  useEffect(() => {
    dispatch(changePage('brandAnalysis'));
  }, []);

  // useEffect(() => {
  //   // '選択済みの第一カテゴリがない時のみfetchAsyncCategory1をする
  //   if (
  //     Boolean(
  //       currentSelectAmazonCategory1 ||
  //         currentSelectRakutenCategory1 ||
  //         currentSelectYahooCategory1
  //     ) == false
  //   ) {
  //     dispatch(fetchFavoriteCategory());
  //     // dispatch(fetchAllCategoryGraphData());
  //     // dispatch(fetchCategoryShareGraphData());
  //     dispatch(fetchAsyncCategory1());
  //   }
  //   dispatch(fetchCategoryBrandShareGraphData());
  //   dispatch(fetchCategoryBrandGraphData());
  //   dispatch(fetchBrandRankData());
  // }, [channel]);

  let categories = '';

  if (channel == 1) {
    categories = amazonCategories;
  } else if (channel == 2) {
    categories = rakutenCategories;
  } else if (channel == 3) {
    categories = yahooCategories;
  }

  // let channelBrandList = [];
  // if (channel == 1) {
  //   channelBrandList = getBrandList.amazon;
  // } else if (channel == 2) {
  //   channelBrandList = getBrandList.rakuten;
  // } else if (channel == 3) {
  //   channelBrandList = getBrandList.yahoo;
  // }

  return (
    <>
      <Box
        sx={{
          backgroundColor: '#FFF8E5',
          height: 'auto',
          minHeight: '100vh',
          width: '100%',
          maxWidth: '100%',
          boxSizing: 'border-box',
          pb: '80px',
          px: { xs: 1.5, sm: 2, md: 3 }
        }}
      >
        <Container
          maxWidth={false}
          disableGutters
          sx={{ width: '100%', maxWidth: '100%', p: 0, boxSizing: 'border-box' }}
        >
          {/* チャンネル・カテゴリ・競合選択：スクロール追従 */}
          <Box
            position="sticky"
            top="42px"
            bgcolor="#FFF8E5"
            zIndex={5}
            sx={{
              width: '100%',
              maxWidth: '100%',
              pt: 0.5,
              pb: 2,
              boxSizing: 'border-box'
            }}
          >
            {/* {channel == 1 && <StickyAnnotation />} */}
            <Box display="flex" alignItems="center" height="33px" mb={1}>
              <Typography fontSize="14px">マーケットビュー</Typography>
              <ArrowForwardIosOutlinedIcon
                sx={{ fontSize: '16px', mx: 1, color: 'gray' }}
              />
              <Typography fontSize="14px" fontWeight="bold">
                店舗/ブランド分析
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexWrap: 'wrap',
                alignItems: 'flex-end',
                columnGap: '24px',
                rowGap: '16px',
                width: '100%',
                maxWidth: '100%',
                boxSizing: 'border-box',
                borderTop: 1,
                borderColor: '#FFFFFF',
                pt: 1.5
              }}
            >
              <Box sx={{ flex: '0 0 auto' }}>
                <NewButtongroup amazonOnly={true} page="brandAnalysis" />
              </Box>
              {!freePlanRegisterModalOpen && (
                <>
                  <Box sx={{ flex: '0 0 auto' }}>
                    <NewPullDown
                      page="brandAnalysis"
                      label="期間"
                      setYokoziku={setYokoziku}
                      graphLoading={
                        graphloading || categoryShareLoading || top100loading
                      }
                    />
                  </Box>
                  <Box sx={{ flex: '0 0 auto' }}>
                    <Typography
                      fontSize="14px"
                      sx={{ mb: 0.75, display: 'block' }}
                    >
                      カテゴリを選択する
                    </Typography>
                    <NewDialogSelect
                      categories={categories}
                      channel={channel}
                      page="brandAnalysis"
                      graphLoading={
                        graphloading || categoryShareLoading || top100loading
                      }
                    />
                  </Box>
                  <Box sx={{ flex: '0 0 auto' }}>
                    <Typography
                      fontSize="14px"
                      sx={{ mb: 0.75, display: 'block' }}
                    >
                      お気に入りカテゴリ
                    </Typography>
                    <FavoriteCategoryPullDown
                      page="brandAnalysis"
                      graphLoading={
                        graphloading || categoryShareLoading || top100loading
                      }
                    />
                  </Box>
                  <Box sx={{ flex: '0 0 auto' }}>
                    <Typography
                      fontSize="14px"
                      sx={{ mb: 0.75, display: 'block' }}
                    >
                      競合を選択
                    </Typography>
                    <DialogCheckbox
                      channel={channel}
                      page="brandAnalysis"
                      section="other"
                      graphLoading={
                        graphloading || categoryShareLoading || top100loading
                      }
                    />
                  </Box>
                </>
              )}
            </Box>
          </Box>
          {!freePlanRegisterModalOpen ? (
            <>
              {/* 選択中カテゴリ・ブランド（ページ共通・各1回） */}
              <Box
                sx={{
                  mt: 1.5,
                  mb: 2,
                  minWidth: 0,
                  display: 'flex',
                  flexDirection: 'column',
                  gap: 0.5
                }}
              >
                <MarketLabel />
                <BrandLabel />
              </Box>

              {/* 1段目：ブランド売上推移｜商品別売上シェア */}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
                  gap: 3,
                  mb: 3,
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0
                }}
              >
                <Box
                  bgcolor="#FFFFFF"
                  borderRadius={3}
                  sx={{
                    p: 2,
                    minHeight: 460,
                    minWidth: 0,
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography sx={{ fontSize: 15, fontWeight: 'bold', mb: 1 }}>
                    ブランド売上推移
                  </Typography>
                  {graphloading ? (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flex={1}
                      minHeight={0}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column'
                        }}
                      >
                        <p>グラフの読み込み中…</p>
                        <CircularProgress />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        alignItems: 'stretch'
                      }}
                    >
                      <BrandTotal yokoziku={yokoziku} />
                    </Box>
                  )}
                </Box>
                <Box
                  bgcolor="#FFFFFF"
                  borderRadius={3}
                  sx={{
                    p: 2,
                    minHeight: 460,
                    minWidth: 0,
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography sx={{ fontSize: 15, fontWeight: 'bold', mb: 1 }}>
                    商品別売上シェア
                  </Typography>
                  {categoryShareLoading ? (
                    <Box
                      display="flex"
                      justifyContent="center"
                      alignItems="center"
                      flex={1}
                      minHeight={0}
                    >
                      <Box
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          flexDirection: 'column'
                        }}
                      >
                        <p>グラフの読み込み中…</p>
                        <CircularProgress />
                      </Box>
                    </Box>
                  ) : (
                    <Box
                      sx={{
                        flex: 1,
                        minHeight: 0,
                        display: 'flex',
                        alignItems: 'stretch'
                      }}
                    >
                      <BrandItemShare />
                    </Box>
                  )}
                </Box>
              </Box>

              {/* 2段目：売上詳細｜シェア詳細 */}
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', lg: '1fr 1fr' },
                  gap: 3,
                  mb: 3,
                  width: '100%',
                  maxWidth: '100%',
                  minWidth: 0
                }}
              >
                <Box
                  bgcolor="#FFFFFF"
                  borderRadius={3}
                  sx={{
                    p: 2,
                    minHeight: 460,
                    minWidth: 0,
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography sx={{ fontSize: 15, fontWeight: 'bold', mb: 1 }}>
                    売上詳細
                  </Typography>
                  {graphloading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex: 1
                      }}
                    >
                      <p>テーブルの読み込み中…</p>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <BrandTable yokoziku={yokoziku} />
                  )}
                </Box>
                <Box
                  bgcolor="#FFFFFF"
                  borderRadius={3}
                  sx={{
                    p: 2,
                    minHeight: 460,
                    minWidth: 0,
                    maxWidth: '100%',
                    boxSizing: 'border-box',
                    display: 'flex',
                    flexDirection: 'column'
                  }}
                >
                  <Typography sx={{ fontSize: 15, fontWeight: 'bold', mb: 1 }}>
                    シェア詳細
                  </Typography>
                  {categoryShareLoading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        flex: 1
                      }}
                    >
                      <p>テーブルの読み込み中…</p>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <BrandItemShareTable />
                  )}
                </Box>
              </Box>

              {/* 3段目：TOP100商品 */}
              <Box mb={3} display="flex" justifyContent="center">
                <Box
                  width="100%"
                  bgcolor="#FFFFFF"
                  borderRadius={3}
                  sx={{ p: 2, minWidth: 0, boxSizing: 'border-box' }}
                >
                  {top100loading ? (
                    <Box
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column'
                      }}
                    >
                      <p>ランキングの読み込み中…</p>
                      <CircularProgress />
                    </Box>
                  ) : (
                    <BrandItemTable yokoziku={yokoziku} />
                  )}
                </Box>
              </Box>
            </>
          ) : (
            <FreePlanRegisterModal
              updateFreePlanRegisterInfosSuccessFlag={
                updateFreePlanRegisterInfosSuccessFlag
              }
              categories={categories}
            />
          )}
        </Container>
      </Box>
    </>
  );
};

export default BrandAnalysis;
